<br />
<br />
<h4 style="font-weight:bold; text-decoration:underline; text-align:center">Selected: Agree</h4>
<br />
<div class="container" style="border:1px solid #bebaba">
  <div class="row">
    <div class="col-md-12" style="font-weight:bold">
      <br /><br />
      If you <b><u>agree</u></b> with your listed purchase information, please complete the Claimant Information below and submit it
      by <b>October 30, 2026</b> (postmarked or submitted online), to the Settlement Administrator at the address listed above.<br /><br />

      If you do <b><u>not agree</u></b> with the listed purchase information <b>
        or wish to submit information about your purchases from Defendant<br /><br />

        House of Raeford
      </b>, please complete the Claimant Information below, as well as the <b>
        Purchase Audit Request form, available on the Settlement
        Website, www.TurkeyLitigation.com
      </b>, and submit them by <b>October 30, 2026</b> (postmarked or submitted online), to the Settlement Administrator at
      the address listed above, along with additional documentation to support your claim (e.g., invoices, purchase information, etc.).<br /><br />

      Documentation must include actual receipts or invoices that include the product name, name of the Defendant manufacturer, date of purchase,
      and net purchase amount. Please submit legible copies. Do not send originals. Keep the originals for your records.<br /><br />
    </div>
  </div>
  <div class="container-fluid">
    <div class="row mt-5" style="margin-left: 0px; margin-right: 0px">
      <div class="col-md-12 text-center" style="background-color: lightgrey; font-size: 1.4em; font-weight: bold">
        Claimant Information
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <form [formGroup]="claimantsInformation" (ngSubmit)="onSubmit()">
          <div class="row mt-3">
            <div class="col-md-6">
              <div class="form-group">
                <label class="titleBold" for="pin">Pin:</label>
                <input type="text" class="form-control" id="pin" formControlName="pin" readonly />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="titleBold" for="uniqueId">Unique ID Number:</label>
                <input type="text" class="form-control" id="uniqueId" formControlName="uniqueId" readonly />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <input type="text" class="form-control" id="agreeOrDisagree" formControlName="agreeOrDisagree" hidden />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="nameOne">Company Name:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" id="nameOne" formControlName="nameOne" placeholder=""
                       autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.nameOne.errors }" />
                <div *ngIf="submitted && f.nameOne.errors" class="invalid-feedback">
                  <div *ngIf="f.nameOne.errors.required">This field is required</div>
                  <div *ngIf="f.nameOne.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.nameOne.errors.maxlength">This field must not be at greater 50 characters</div>
                  <div *ngIf="f.nameOne.errors.pattern">Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="title">Title:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" id="title" formControlName="title" autocomplete="no"
                       trim="blur" [ngClass]="{ 'is-invalid': submitted && f.title.errors }" />
                <div *ngIf="submitted && f.title.errors" class="invalid-feedback">
                  <div *ngIf="f.title.errors.required">This field is required</div>
                  <div *ngIf="f.title.errors.maxlength">This field must not be at greater 50 characters</div>
                  <div *ngIf="f.title.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.title.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens,
                    brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="attention">Contact Name:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" id="attention" formControlName="attention" placeholder=""
                       autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.attention.errors }" />
                <div *ngIf="submitted && f.attention.errors" class="invalid-feedback">
                  <div *ngIf="f.attention.errors.required">This field is required</div>
                  <div *ngIf="f.attention.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.attention.errors.maxlength">This field must not be at greater 50 characters</div>
                  <div *ngIf="f.attention.errors.pattern">Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)</div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="streetOne">Street Address 1:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" id="streetOne" formControlName="streetOne" autocomplete="no"
                       trim="blur" [ngClass]="{ 'is-invalid': submitted && f.streetOne.errors }" />
                <div *ngIf="submitted && f.streetOne.errors" class="invalid-feedback">
                  <div *ngIf="f.streetOne.errors.required">This field is required</div>
                  <div *ngIf="f.streetOne.errors.maxlength">This field must not be at greater 50 characters</div>
                  <div *ngIf="f.streetOne.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.streetOne.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens,
                    brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="streetTwo">Street Address 2:</label>
                <input type="text" class="form-control" id="streetTwo" formControlName="streetTwo" autocomplete="no"
                       trim="blur" [ngClass]="{ 'is-invalid': submitted && f.streetTwo.errors }" />
                <div *ngIf="submitted && f.streetTwo.errors" class="invalid-feedback">
                  <div *ngIf="f.streetTwo.errors.maxlength">This field must not be at greater 50 characters</div>
                  <div *ngIf="f.streetTwo.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.streetTwo.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens,
                    brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row rowformat">
            <div class="col-md-6">
              <div class="form-group">
                <label for="country"><b>Country</b>:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <select class="form-control" formControlName="country" (change)="getCountryValue($event)" [disabled]="allCountries.length === 0" [ngClass]="{ 'is-invalid': submitted && f.country.errors }">
                  <option value="">Please Select A Country</option>
                  <option *ngFor="let allcountry of allCountries">
                    {{allcountry.Name}}
                  </option>
                </select>
                <div *ngIf="submitted && f.country.errors" class="invalid-feedback">
                  <div *ngIf="f.country.errors.required">This field is required</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="city"><b>City</b>:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" formControlName="city" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.city.errors }" />
                <div *ngIf="(changed || submitted) && f.city.errors" class="invalid-feedback">
                  <div *ngIf="f.city.errors.required">This field is required</div>
                  <div *ngIf="f.city.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.city.errors.maxlength">This field must not be at greater 40 characters</div>
                  <div *ngIf="f.city.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens,
                    brackets,
                    ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="showDivProvince">
            <div class="row rowformat">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="province"><b>Province:</b><span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                  <input type="text" class="form-control" formControlName="province" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.province.errors }" />
                  <div *ngIf="(changed || submitted) && f.province.errors" class="invalid-feedback">
                    <div *ngIf="f.province.errors.required">This field is required</div>
                    <div *ngIf="f.province.errors.minlength">This field must be at least 2 characters</div>
                    <div *ngIf="f.province.errors.maxlength">This field must not be at greater 40 characters</div>
                    <div *ngIf="f.province.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label  for="postalCode"><b>Postal Code:</b></label>
                  <input type="text" class="form-control" formControlName="postalCode" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': f.postalCode.errors }" />
                  <div *ngIf="f.postalCode.errors" class="invalid-feedback">
                    <div *ngIf="f.postalCode.errors.maxlength">This field must not be greater than 10 characters</div>
                    <div *ngIf="f.postalCode.errors.pattern">
                      Only use letters, numbers, periods, spaces, hyphens, brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row rowformat" *ngIf="showDivCityStateZip">
            <div class="col-md-6">
              <div class="form-group">
                <label for="state"><b>State</b>:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <select class="form-control" formControlName="state" [ngClass]="{ 'is-invalid': submitted && f.state.errors }">
                  <option value="">Please Select A State</option>
                  <option *ngFor="let allstate of allStates">
                    {{allstate.Name}}
                  </option>
                </select>
                <div *ngIf="(changed || submitted) && f.state.errors" class="invalid-feedback">
                  <div *ngIf="f.state.errors.required">This field is required</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="zip"><b>Zip Code:</b>:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" formControlName="zip" autocomplete="no" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.zip.errors }" />
                <div *ngIf="(changed || submitted) && f.zip.errors" class="invalid-feedback">
                  <div *ngIf="f.zip.errors.required">This field is required</div>
                  <div *ngIf="f.zip.errors.pattern">
                    US zip Code with format 99999 or 99999-9999 alone are
                    accepted
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="email">Email Address:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" id="email" formControlName="email" autocomplete="no"
                       trim="blur" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                  <div *ngIf="f.email.errors.required">This field is required</div>
                  <div *ngIf="f.email.errors.maxlength">This field must not be at greater 255 characters</div>
                  <div *ngIf="f.email.errors.pattern">This is not a valid email address</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label class="titleBold" for="phoneType">Primary Phone Type:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <select class="form-control" formControlName="phoneType" [ngClass]="{ 'is-invalid': submitted && f.phoneType.errors }">
                  <option value="">Please Select Phone Type</option>
                  <option value="Cell">Cell</option>
                  <option value="Landline">Landline</option>
                </select>
                <div *ngIf="submitted && f.phoneType.errors" class="invalid-feedback">
                  <div *ngIf="f.phoneType.errors.required">This field is required</div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="titleBold" for="phoneNumber">Primary Phone Number:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" mask="000 000-0000" class="form-control" id="phoneNumber" formControlName="phoneNumber" placeholder=""
                       autocomplete="off" trim="blur" [ngClass]="{ 'is-invalid': submitted && f.phoneNumber.errors }" />
                <div *ngIf="submitted && f.phoneNumber.errors" class="invalid-feedback">
                  <div *ngIf="f.phoneNumber.errors.required">This field is required</div>
                  <div *ngIf="f.phoneNumber.errors.minlength">This field must be at least 10 digits</div>
                  <div *ngIf="f.phoneNumber.errors.maxlength">This field must not be at greater 10 digits</div>
                  <div *ngIf="f.phoneNumber.errors.pattern">Only use numbers</div>
                </div>
              </div>
            </div>
          </div>


          <div class="row mt-4" style="margin-left: 0px; margin-right: 0px">
            <div class="col-md-12 text-center" style="background-color: lightgrey; font-size: 1.4em; font-weight: bold">
              Review Your Purchase Information
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-12">
              The total award amount you receive will be calculated based on the purchase information from records available from Defendants
              and updated based on any audits for information obtained during the settlement distribution process.
              <b><i>Please note that Defendant House of Raeford did not provide any purchase data</i></b>.
              Your total known Settlement qualifying purchases from Defendants (except for House of Raeford) for the period between January 1,
              2010 through December 31, 2016 are ${{au.purchaseNetTotal | number:'1.7-7'}}. Details about the amount of your qualifying purchases are on page 3.
              <b><i>To include purchases from Defendant House of Raeford with your claim</i></b>, you must submit the Purchase Audit Request Form and provide
              the requested information.
            </div>
          </div>
          <div class="row mt-4" style="margin-left: 0px; margin-right: 0px">
            <div class="col-md-12 text-center" style="background-color: lightgrey; font-size: 1.4em; font-weight: bold">
              Purchase Information
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-md-6 float-left">
              <b>UniqueId:</b>  {{au.uniqueId}}
            </div>
            <br />
            <div class="col-md-4 float-left">
              <b>Pin:</b>  {{au.pin}}
            </div>
            <div class="col-md-12 mt-3">
              <table class="table table-bordered table-striped" #listofInformation>
                <thead>
                  <tr>
                    <th>DEFENDANT</th>
                    <th>
                      2010
                    </th>
                    <th>
                      2011
                    </th>
                    <th>
                      2012
                    </th>
                    <th>
                      2013
                    </th>
                    <th>
                      2014
                    </th>
                    <th>
                      2015
                    </th>
                    <th>
                      2016
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="font-weight:bold">Butterball</td>

                    <td>${{au.butterball2010}}</td>
                    <td>${{au.butterball2011}}</td>
                    <td>${{au.butterball2012}}</td>
                    <td>${{au.butterball2013}}</td>
                    <td>${{au.butterball2014}}</td>
                    <td>${{au.butterball2015}}</td>
                    <td>${{au.butterball2016}}</td>
                  </tr>
                  <tr>
                    <td style="font-weight:bold">Cargill</td>
                    <td>${{au.cargill2010}}</td>
                    <td>${{au.cargill2011}}</td>
                    <td>${{au.cargill2012}}</td>
                    <td>${{au.cargill2013}}</td>
                    <td>${{au.cargill2014}}</td>
                    <td>${{au.cargill2015}}</td>
                    <td>${{au.cargill2016}}</td>
                  </tr>
                  <tr>
                    <td style="font-weight:bold">Cooper Farms</td>
                    <td>${{au.cooperFarms2010}}</td>
                    <td>${{au.cooperFarms2011}}</td>
                    <td>${{au.cooperFarms2012}}</td>
                    <td>${{au.cooperFarms2013}}</td>
                    <td>${{au.cooperFarms2014}}</td>
                    <td>${{au.cooperFarms2015}}</td>
                    <td>${{au.cooperFarms2016}}</td>
                  </tr>
                  <tr>
                    <td style="font-weight:bold">Farbest Foods</td>
                    <td>${{au.farbestFoods2010}}</td>
                    <td>${{au.farbestFoods2011}}</td>
                    <td>${{au.farbestFoods2012}}</td>
                    <td>${{au.farbestFoods2013}}</td>
                    <td>${{au.farbestFoods2014}}</td>
                    <td>${{au.farbestFoods2015}}</td>
                    <td>${{au.farbestFoods2016}}</td>
                  </tr>
                  <tr>
                    <td style="font-weight:bold">Foster Farms</td>
                    <td>${{au.fosterFarms2010}}</td>
                    <td>${{au.fosterFarms2011}}</td>
                    <td>${{au.fosterFarms2012}}</td>
                    <td>${{au.fosterFarms2013}}</td>
                    <td>${{au.fosterFarms2014}}</td>
                    <td>${{au.fosterFarms2015}}</td>
                    <td>${{au.fosterFarms2016}}</td>
                  </tr>
                  <tr>
                    <td style="font-weight:bold">Hormel</td>
                    <td>${{au.hormel2010}}</td>
                    <td>${{au.hormel2011}}</td>
                    <td>${{au.hormel2012}}</td>
                    <td>${{au.hormel2013}}</td>
                    <td>${{au.hormel2014}}</td>
                    <td>${{au.hormel2015}}</td>
                    <td>${{au.hormel2016}}</td>
                  </tr>
                  <tr>
                    <td style="font-weight:bold">Perdue</td>
                    <td>${{au.perdue2010}}</td>
                    <td>${{au.perdue2011}}</td>
                    <td>${{au.perdue2012}}</td>
                    <td>${{au.perdue2013}}</td>
                    <td>${{au.perdue2014}}</td>
                    <td>${{au.perdue2015}}</td>
                    <td>${{au.perdue2016}}</td>
                  </tr>
                  <tr>
                    <td style="font-weight:bold">Prestage</td>
                    <td>${{au.prestage2010}}</td>
                    <td>${{au.prestage2011}}</td>
                    <td>${{au.prestage2012}}</td>
                    <td>${{au.prestage2013}}</td>
                    <td>${{au.prestage2014}}</td>
                    <td>${{au.prestage2015}}</td>
                    <td>${{au.prestage2016}}</td>
                  </tr>
                  <tr>
                    <td style="font-weight:bold">Tyson</td>
                    <td>${{au.tyson2010}}</td>
                    <td>${{au.tyson2011}}</td>
                    <td>${{au.tyson2012}}</td>
                    <td>${{au.tyson2013}}</td>
                    <td>${{au.tyson2014}}</td>
                    <td>${{au.tyson2015}}</td>
                    <td>${{au.tyson2016}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-md-12" style="text-align:center; font-size:1.3em">
              <b><u>Purchase Total</u></b>&nbsp;&nbsp;&nbsp;${{au.purchaseNetTotal | number:'1.7-7'}}<br /><br />

            </div>
          </div>
          <div class="row mt-4" style="margin-left: 0px; margin-right: 0px">
            <div class="col-md-12 text-center" style="background-color: lightgrey; font-size: 1.4em; font-weight: bold">
              Sign Statement
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-12">
              By signing below, I/we certify that (1) the above and foregoing information is true and correct; (2) I warrant
              that I am duly authorized and have the legal capacity to sign this Claim Form on behalf of the direct purchaser
              entity; (3) I/we are not officers, directors, or employees of any Defendant or co-conspirator; any entity in which
              any Defendant or co-conspirator has a controlling interest; any entity with an interest, controlling or non-controlling,
              in a Defendant or their co-conspirator; any entity where an individual owner, trust, and/or holding company also had an
              interest in any Defendant of greater than 5% during any year of the Class Period; an affiliate, legal representative,
              heir, or assign of any Defendant or co-conspirator; or a federal, state, or local governmental entity; a judicial
              officer presiding over this action and the members of his/her immediate family and judicial staff; or a co-conspirator
              identified in this action; (4) I/we did not previously exclude myself/themselves from the Certified Class; and (5)
              I/we agree to submit additional information, if requested, in order for the Settlement Administrator to process my/our claim.
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-md-12">
              <div class="form-group">
                <label class="titleBold" for="signature">Electronic Signature:<span style="color:red; font-weight:bold" class="required"> *This is Required</span></label>
                <input type="text" class="form-control" id="signature" formControlName="signature" autocomplete="no"
                       trim="blur" [ngClass]="{ 'is-invalid': submitted && f.signature.errors }" />
                <div *ngIf="submitted && f.signature.errors" class="invalid-feedback">
                  <div *ngIf="f.signature.errors.required">This field is required</div>
                  <div *ngIf="f.signature.errors.maxlength">This field must not be at greater 50 characters</div>
                  <div *ngIf="f.signature.errors.minlength">This field must be at least 2 characters</div>
                  <div *ngIf="f.signature.errors.pattern">
                    Only use letters, numbers, periods, spaces, hyphens,
                    brackets, ampersands, apostophes, parentheses slash(/), pound sign(#)
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <re-captcha formControlName="googleRecaptchaToken" (resolved)="resolved($event)" [ngClass]="{ 'is-invalid':  f.googleRecaptchaToken.errors }"></re-captcha>
                <div *ngIf="f.googleRecaptchaToken.errors" class="invalid-feedback">
                  <div *ngIf="f.googleRecaptchaToken.errors.required" style="color:red; font-size:80%">This field is required</div>
                </div>
                <!--<div style="color:#dc3545; font-size:80%; font-weight:bold">This field is required*</div>-->

              </div>
            </div>
          </div>
          <br />
          <div class="row" *ngIf="showSubmittalErrorWarning" style="background-color:lightpink">
            <div class="col-md-12 text-center" style="font-weight:bold">
              Claim Submission Failed
            </div>
          </div>
          <br />
          <ul class="list-inline text-center">
            <li><button type="submit" class="btn btn-primary" [disabled]="clicked">SUBMIT</button></li>
          </ul>
          <br />
        </form>
      </div>
    </div>
  </div>

























</div>
